<template>
  <footer class="container-fluid" id="main-footer">
    <div class="col-md-12 p-4">
      <ul>
        <li v-for="item in footerMenu" :key="item._id" >
          <router-link exact :to="{ name: 'page', params: {'slug': item.slug }}">{{ item.name }}</router-link>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "myfooter",

  computed: mapState({
    footerMenu: state => state.footerMenu
  }),

  mounted() {
    this.$store.dispatch("loadFooterMenu");
  }
};
</script>

<style lang="scss">
#main-footer {
  background-color: rgb(70, 68, 68);
  color: #ffffff;
  text-align: center;
  position: fixed;
  bottom: 0;
  ul {
    list-style-type: none;
    li {
      margin: 0 10px;
      display: inline-block;
      a {
        color: #ffffff !important;
      }
    }
  }
}
</style>
